import CryptoJS from "react-native-crypto-js";
import helpers from "../components/_helpers/helpersFunction";


const register = (data,context) => {
    
    try{

        let temp = CryptoJS.AES.encrypt(JSON.stringify(data), 'Clav£Inc0ntr1<>!').toString();
        return fetch(process.env.REACT_APP_APIADDRESS+"/users/register", {
            method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({utente:temp})
        })
        .then(response =>  response.json())
        .then(res => {
            //TIKTOK PIXEL  E ALTRI
            //window.ttq.track('Subscribe')

            // ----- se c'è un errore
            if(!res.result){
                return res
            }else{
                helpers.retargetingScripts("lead")
                let bytes  = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE)
                let user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
                return user;
            }
        })
    }catch(err){
        fetch(process.env.REACT_APP_APIADDRESS+"/log/client",{ 
            method: 'post', 
            headers: {
              'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                subject:"Errore authServices",
                messaggio:{errore:err.message}
            })
        })
    }
}



const registerOnExternalEmail = (data,context) => {
    
    try{
       
        let temp = CryptoJS.AES.encrypt(JSON.stringify(data), 'Clav£Inc0ntr1<>!').toString();
        return fetch(process.env.REACT_APP_APIADDRESS+"/users/extSign_register", {
            method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({utente:temp})
        })
        .then(response => response.json())
        .then(res => {
            
            if(!res.result){
                return res
            }else{
                helpers.retargetingScripts("lead")
                let bytes  = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE)
                let user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
                return user;
            }
        })
    }catch(err){
        fetch(process.env.REACT_APP_APIADDRESS+"/log/client",{ 
            method: 'post', 
            headers: {
              'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                subject:"Errore authServices",
                messaggio:{errore:err.message}
            })
        })
    }
}


const verify = (data) => {
    const utente = {
        "token" : data,
        "trackerId":localStorage.getItem('trackerId')
    }
    return fetch(process.env.REACT_APP_APIADDRESS+"/users/verify", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(utente)
    })
    .then(response => response.json())
    .then(res => {

        if(res.verify === false || res.error){
            return res
        }

        let bytes  = CryptoJS.AES.decrypt(res.verify, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));  
        //console.log("USER:",decryptedData)
        return decryptedData;
        
    });
};

const login = (data) => {
    const utente = {
        "email": data.email,
        "password": data.password,
    }

    return fetch(process.env.REACT_APP_APIADDRESS+"/users/authenticate", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
               
        if (res.token) {
            localStorage.setItem('token', res.token);
            localStorage.setItem('trackerId', res.clickid);
        }
        return res;
    });

};


const resetPassword = (data) => {

    const utente = {
        "password": data.password,
        "email":data.email
    }

    return fetch(process.env.REACT_APP_APIADDRESS+"/users/changePassword", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ data.token
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
        return res;
    });

};


const autoLogin = (data) => {
    const utente = {
        "email":data.email
    }

    return fetch(process.env.REACT_APP_APIADDRESS+"/users/autoLogin", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ data.token
        },
        body: JSON.stringify(utente)
    })
    .then(response => response.json())
    .then(res => {
        return res;
    });
}



const getTokenForReset = (data) => {
    const utente = {
        "email": data.email,
        "servizio": data.servizio,
    }

    return fetch(process.env.REACT_APP_APIADDRESS+"/users/getTokenForReset", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
        console.log(res);
        console.log(res.result);
        if (res.result === "OK") {
           return true;
        }else{
            return false;
        }
    });
};


const LP_authWithGoogle = (data) => {



    return fetch(process.env.REACT_APP_APIADDRESS+"/users/auth/google", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
        if (typeof res !== 'string') return res;
        let bytes  = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
        let response = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));  
        return response
       
    });
}



const HOME_authWithGoogle = (data) => {



    return fetch(process.env.REACT_APP_APIADDRESS+"/users/auth/google/home", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
        if (typeof res !== 'string') return res;
        let bytes  = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
        let response = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));  
        return response
       
    });
}


// ===================== Funzioni per accesso/login con facebook =====================

// Riceviamo "data" = payload assemblato nel frontend
const LP_authWithFacebook = (data) => {
    
    // Chiamiamo l'api del backend mandando il payload (prende url da .env)
    return fetch(process.env.REACT_APP_APIADDRESS + "/users/auth/facebook", {
        method: 'POST',
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    })
    // trasformiamo risposta in oggetto javascript
    .then(response => response.json())
    // Res può essere di due tipi: 
    // stringa se utente esistente
    // oggetto se utente nuovo da registrare
    .then(res => {
        // Se needRegistration = true -> Non serve decriptare
        if (res.needsRegistration) return res
        if (typeof res !== 'string') return res 
        let bytes = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE)
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    })
}


// Riceviamo "data" = payload assemblato nel frontend
const Home_authWithFacebook = (data) => {
    // Chiamiamo l'api del backend mandando il payload (prende url da .env)
    return fetch(process.env.REACT_APP_APIADDRESS + "/users/auth/facebook/home", {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    })
    // trasformiamo risposta in oggetto javascript
    .then(response => response.json())
    // Res può essere di due tipi: 
    // stringa se utente esistente
    // oggetto se utente nuovo da registrare
    .then(res => {
        // Se needRegistration = true -> Non serve decriptare
        if (res.needsRegistration) return res
        if (typeof res !== 'string') console.log("[SOCIAL][FB home] risposta backend NON stringa (probabile errore, il decrypt fallirà):", res)
        let bytes = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE)
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    })
}

// =====================    Fine login Facebook =====================

// ===================== Funzioni per accesso/login con Apple =====================

const LP_authWithApple = (data) => {
    return fetch(process.env.REACT_APP_APIADDRESS + "/users/auth/apple", {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
        if (typeof res !== 'string') return res;    // oggetto-errore {result:false, message:"error-xxxx"}
        let bytes = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    });
}

const Home_authWithApple = (data) => {
    return fetch(process.env.REACT_APP_APIADDRESS + "/users/auth/apple/home", {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
        if (typeof res !== 'string') return res;    // oggetto-errore {result:false, message:"error-xxxx"}
        let bytes = CryptoJS.AES.decrypt(res, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    });
};

// =====================    Fine login Apple =====================

async function changeEmail(oldEmail,newEmail,servizio){
    
    const token = localStorage.getItem('token')
    
    const utente = {
        'oldEmail':oldEmail,
        'newEmail': newEmail,
        'servizio': servizio
    }

    return await fetch(process.env.REACT_APP_APIADDRESS+"/users/changeEmail", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ token
        },
        body: JSON.stringify(utente)
    })
    .then(response => response.json())
    .then(res => {
        return res;
    })
    .catch(err=>{
        console.log(err)
    })
}


async function confirmEmail(clickid,token,servizio){

    const utente = {
        'clickid':clickid,
        'servizio': servizio
    }

    return fetch(process.env.REACT_APP_APIADDRESS+"/users/confirmEmail", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ token
        },
        body: JSON.stringify(utente)
    })
    .then(response => response.json())
    .then(res => {
        return res;
    });
}


const logout = () => {
    localStorage.removeItem("token");
    window.location.replace("/");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("token"));
};

export default {
  register,
  registerOnExternalEmail,
  login,
  logout,
  getCurrentUser,
  verify,
  getTokenForReset,
  resetPassword,
  autoLogin,
  changeEmail,
  confirmEmail,
  LP_authWithGoogle,
  HOME_authWithGoogle,
  LP_authWithFacebook,
  Home_authWithFacebook,
  LP_authWithApple,
  Home_authWithApple
};